import React from 'react';
import { DefaultSuggestion } from '../../../contracts';
import { PickupAndDeliveryOption } from '../../../contracts/AppliedFilters';
import FreeShipping from '../../../icons/FreeShipping';
import GreatDealTag from '../../../icons/GreatDealTag';
import NewPrice from '../../../icons/NewPrice';
import PricingArrow from '../../../icons/PricingArrow';
import SolidPlugIcon from '../../../icons/SolidPlugIcon';
import { getWeekDay } from '../../../utils';

export type RecommendedLink = DefaultSuggestion & {
  icon?: React.JSX.Element;
};

function recommendedSearches(isRestrictedState: boolean): RecommendedLink[] {
  return [
    {
      text: 'Shop Great Deals',
      icon: <GreatDealTag />,
      filters: { tagIds: ['104'] }
    },
    {
      text: isRestrictedState ? 'New Prices' : 'Price Drops',
      icon: isRestrictedState ? <NewPrice /> : <PricingArrow />,
      filters: { tagIds: ['103'] }
    },
    {
      text: 'Free Shipping',
      icon: <FreeShipping />,
      filters: { isFreeDelivery: true }
    },
    {
      text: 'Clean Vehicle Tax Credit',
      icon: <SolidPlugIcon />,
      filters: { tagIds: ['116'] }
    },
    {
      text: 'Cars Under $20,000',
      filters: { price: { min: 7990, max: 20000 } }
    },
    {
      text: `Delivery by ${getWeekDay(4)}`,
      filters: {
        earliestDayToDeliveryOrPickup: {
          days: 4,
          pickupAndDeliveryOption:
            'pickupAndDelivery' as PickupAndDeliveryOption
        }
      }
    }
  ];
}

export default recommendedSearches;
